import { ElementRef } from '@angular/core';
import { GridApi, IFilterParams } from 'ag-grid-community';

export const getMaxAdjustableData = (gridApi: GridApi, element: ElementRef) => {
  const tableSize = element.nativeElement.offsetHeight;
  const tableElementsSize = gridApi.getSizesForCurrentTheme();
  return (tableSize - tableElementsSize.headerHeight) / tableElementsSize.rowHeight;
};

export const setTableLayout = (gridApi: GridApi, dataLength: number, maxData: number) => {
  if (dataLength < maxData) {
    gridApi.setDomLayout('autoHeight');
  } else {
    gridApi.setDomLayout('normal');
  }
};

export const setTableLayoutAfterFiltering = (gridApi: GridApi, maxData: number) => {
  setTableLayout(gridApi, getNRowsAfterFilter(gridApi), maxData);
  handleNoRowsOverlay(gridApi);
};

export const triggerFileDownload = (file: Blob, filename: string) => {
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const handleNoRowsOverlay = (gridApi: GridApi) => {
  if (getNRowsAfterFilter(gridApi) === 0) {
    gridApi.showNoRowsOverlay();
  } else {
    gridApi.hideOverlay();
  }
};

export const changeFilterCallback = (params: IFilterParams) => {
  params.filterChangedCallback();
  handleNoRowsOverlay(params.api);
};

function getNRowsAfterFilter(gridApi: GridApi): number {
  let nRows = 0;
  gridApi.forEachNodeAfterFilter((n) => (nRows += 1));
  return nRows;
}
